"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Search = _interopRequireDefault(require("./Search"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function getCategoryId() {
  var _getInsidedData$categ, _getInsidedData, _getInsidedData$categ2;

  if (typeof window === 'undefined') return null;
  return (_getInsidedData$categ = (_getInsidedData = (0, _insidedDataStorage.getInsidedData)('content')) === null || _getInsidedData === void 0 ? void 0 : (_getInsidedData$categ2 = _getInsidedData.category) === null || _getInsidedData$categ2 === void 0 ? void 0 : _getInsidedData$categ2.id) !== null && _getInsidedData$categ !== void 0 ? _getInsidedData$categ : null;
}

var SearchForm = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SearchForm, _Component);

  var _super = _createSuper(SearchForm);

  function SearchForm() {
    (0, _classCallCheck2.default)(this, SearchForm);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(SearchForm, [{
    key: "render",
    value: function render() {
      var _getCategoryId;

      var _this$props = this.props,
          isFederatedSkilljarSearch = _this$props.isFederatedSkilljarSearch,
          isFederatedSalesforceSearch = _this$props.isFederatedSalesforceSearch,
          isFederatedFreshdeskSearch = _this$props.isFederatedFreshdeskSearch,
          aiSearchSummary = _this$props.aiSearchSummary,
          isGuest = _this$props.isGuest,
          aiSmartSearchEnableForAllRoles = _this$props.aiSmartSearchEnableForAllRoles,
          searchInContentCategories = _this$props.searchInContentCategories,
          searchInProductAreas = _this$props.searchInProductAreas,
          liveSearchSuggestedQuestions = _this$props.liveSearchSuggestedQuestions,
          forethoughtAgent = _this$props.forethoughtAgent,
          centered = _this$props.centered;
      return (0, _preact.h)("form", {
        method: "get",
        action: (0, _absoluteUrlRuntime.resolveUrl)("/search/index")
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('searchbox', 'searchbox--large', 'qa-search-area')
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('searchbox__input', 'algolia-search--forum', 'qa-menu-search-input')
      }, (0, _preact.h)(_Search.default, {
        isFederatedSalesforceSearch: isFederatedSalesforceSearch,
        isFederatedSkilljarSearch: isFederatedSkilljarSearch,
        isFederatedFreshdeskSearch: isFederatedFreshdeskSearch,
        searchInContentCategories: searchInContentCategories,
        searchInProductAreas: searchInProductAreas,
        category: (_getCategoryId = getCategoryId()) !== null && _getCategoryId !== void 0 ? _getCategoryId : undefined,
        isParentCategory: false // TODO implement this and isParentCategory when extending this feature to category page
        ,
        aiSearchSummary: aiSearchSummary,
        isGuest: isGuest,
        aiSmartSearchEnableForAllRoles: aiSmartSearchEnableForAllRoles,
        liveSearchSuggestedQuestions: liveSearchSuggestedQuestions,
        forethoughtAgent: forethoughtAgent,
        centered: centered
      }))));
    }
  }]);
  return SearchForm;
}(_preact.Component);

exports.default = SearchForm;
var cssAnchorName = 'search-form-v2';
exports.cssAnchorName = cssAnchorName;